<template>
    <div class="container">
        <div class="ding">
          <div class="one">
            <span class="biao" >产品与服务</span>
            <span class="ti1" >Product And Service</span>
            <div class="xian"></div>

          </div>
            <div class="one">
                <div class="div1">产品中心</div>
              <button class="button1">
                <router-link
                        :to="{ path: '/chan/first'} "
                >
                  <span class="span3">了解更多</span>
                </router-link>
                <span class="span4">→</span></button>
            </div>
            <div class="two">
              <div class="div1">PTT养猪学习院</div>
              <button class="button1">
                <router-link
                        :to="{ path: '/chan/second'} "
                >
                  <span class="span3">了解更多</span>
                </router-link><span class="span4">→</span>
              </button>
            </div>
            <div class="three">
              <div class="div1">PSY应用研究院</div>
              <button class="button1">
                <a href="#/chan/third">
                  <span class="span3">了解更多</span>
                </a><span class="span4">→</span>
              </button>
            </div>
            <!-- <div  class="four">
              <div class="div1">合作案例</div>
              <button class="button1">
                <a href="#/chan/fourth">
                  <span class="span3">了解更多</span>
                </a><span class="span4">→</span></button>
            </div> -->
            <!-- <div class="five">
              <div class="div1">产业服务</div>
              <button class="button1">
                <a  href="#/chan/fifth">
                  <span class="span3">了解更多</span>
                </a><span class="span4">→</span>
              </button>
            </div> -->
        </div>
    </div>
</template>

<script>
  export default {
    name: "Xuan",
  }
</script>

<style scoped>
    .container{
        height: 100vh;
        background-image: url("../../../assets/9.png");
      background-repeat: no-repeat;
      background-size:100% 100%;
    }
    .ding{
      height: 100vh;
        display: flex;
    }

    .one{
        flex: 1;
        /* width: 20%; */
        height: 100vh;
        position: relative;
    }
    .one .biao{
      height: 3.3708vh;
      font-size: 2.0833vw;
      font-family: Adobe Heiti Std, Adobe Heiti Std-R;
      font-weight: 700;
      color: #242424;
      position: absolute;
      margin-top: 7.9588vh;
      margin-left:5.5729vw ;
      z-index:99999;
    }
    .ti1{
      z-index:99999;
      width: 18.75vw;
      height: 3.3708vh;
      font-size: 1.7vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #929292;
      position: absolute;
      margin-top: 9.1vh;
      margin-left:16.7396vw;
    }
    .xian{
      z-index:99999;
      width: 16.6667vw;
      height: 0.6554vh;
      background: #1EA364;
      position: absolute;
      margin-top: 13.0596vh;
      margin-left:5.5729vw;
    }
    .one .div1{
      height: 7.8652vh;
      font-size: 2.0833vw;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #595757;
      position: absolute;
      margin-top:27.1536vh;
      margin-left:6.15vw;
    }
    .one .span1{
      height: 7.8652vh;
      font-size: 2.0833vw;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #595757;
      position: absolute;
      margin-top:30.8989vh;
      margin-left:3.9063vw;
    }
    .one .button1{
      /* width: 8.8542vw; */
      height: 5.1498vh;
      border: 0.1563vw solid #1EA364;
      border-radius: 0.1563vw;
      position: absolute;
      margin-top:58.6142vh;
      margin-left:5.3125vw;
      background-color: transparent;
    }
    .one .span3{
      height: 1.779vh;
      font-size: 1.0417vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #1EA364;
    }
    .one .span4{
      height: 0.8427vh;
      font-size: 1.0417vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #1EA364;
    }
    .one:hover,.one:active {
        background-image: url("../../../assets/13213211 31.jpg");
        background-size: 100% 100%;
        background-repead: no-repead;
    }
    .one:hover .div1{
      color: white;
    }
    .one:hover .span1{
      color: white;
    }
    .one:hover .button1{
      background: #1EA364;
     }
    .one:hover .span3{
      color: white;
    }
    .one:hover .span4{
      color: white;
    }

    .two{
        flex: 1;
        /* width: 20%; */
        height: 100vh;
        text-align: center;
        position: relative;
    }
    .two .div1{
      height: 7.8652vh;
      font-size: 2.0833vw;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #595757;
      position: absolute;
      margin-top:27.1536vh;
      margin-left:3.0708vw;
    }
    .two .button1{
      /* width: 8.8542vw; */
      height: 5.1498vh;
      border: 0.1563vw solid #1EA364;
      border-radius: 0.1563vw;
      margin-top:58.6142vh;
      background-color: transparent;

    }
    .two .span3{
      height: 1.779vh;
      font-size: 1.0417vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #1EA364;
    }
    .two .span4{
      height: 0.8427vh;
      font-size: 1.0417vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #1EA364;
    }

    .two:hover,.two:active {
        background-image:url("../../../assets/31.jpg");
        background-size: 100% 100%;
        background-repead: no-repead;
    }
    .two:hover .div1{
      color: white;
    }
    .two:hover .button1{
      background: #1EA364;
    }
    .two:hover .span3{
      color: white;
    }
    .two:hover .span4{
      color: white;
    }
  .three{
        flex: 1;
    /* width: 20%; */
    height: 100vh;
    text-align: center;
    position: relative;
  }
    .three .div1{
      height: 7.8652vh;
      font-size: 2.0833vw;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #595757;
      position: absolute;
      margin-top:27.1536vh;
      margin-left:3.1917vw;
    }
    .three .button1{
      /* width: 8.8542vw; */
      height: 5.1498vh;
      border: 0.1563vw solid #1EA364;
      border-radius: 0.1563vw;
      margin-top:58.6142vh;
      background-color: transparent;
    }
    .three .span3{
      height: 1.779vh;
      font-size: 1.0417vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #1EA364;
    }
    .three .span4{
      height: 0.8427vh;
      font-size: 1.0417vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #1EA364;
    }
    .three:hover,.three:active {
      background-image:url("../../../assets/13213200131.jpg");
      background-size: 100% 100%;
      background-repead: no-repead;
    }
    .three:hover .div1{
      color: white;
    }
    .three:hover .button1{
      background: #1EA364;
    }
    .three:hover .span3{
      color: white;
    }
    .three:hover .span4{
      color: white;
    }

  .four{
        flex: 1;
    /* width: 20%; */
    height: 100vh;
    text-align: center;
    position: relative;
  }
    .four .div1{
      height: 7.8652vh;
      font-size: 2.0833vw;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #595757;
      position: absolute;
      margin-top:27.1536vh;
      margin-left:5.35vw;
    }
    .four .button1{
      /* width: 8.8542vw; */
      height: 5.1498vh;
      border: 3px solid #1EA364;
      border-radius: 0.1563vw;
      margin-top:58.6142vh;
      background-color: transparent;
    }
    .four .span3{
      height: 1.779vh;
      font-size: 1.0417vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #1EA364;
    }
    .four .span4{
      height: 0.8427vh;
      font-size: 1.0417vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #1EA364;
    }
    .four:hover,.four:active {
      background-image:url("../../../assets/111132132131.jpg");
      background-size: 100% 100%;
      background-repead: no-repead;
    }
    .four:hover .div1{
      color: white;
    }
    .four:hover .button1{
      background: #1EA364;
    }
    .four:hover .span3{
      color: white;
    }
    .four:hover .span4{
      color: white;
    }
  .five{
    width: 20%;
    height: 100vh;
    text-align: center;
    position: relative;
  }
    .five .div1{
      height: 7.8652vh;
      font-size: 2.0833vw;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #595757;
      position: absolute;
      margin-top:27.1536vh;
      margin-left:5.35vw;
    }
    .five .button1{
      width: 8.8542vw;
      height: 5.1498vh;
      border: 0.1563vw solid #1EA364;
      border-radius: 0.1563vw;
      margin-top:58.6142vh;
      background-color: transparent;
    }
    .five .span3{
      height: 1.779vh;
      font-size: 1.0417vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #1EA364;
    }
    .five .span4{
      height: 0.8427vh;
      font-size: 1.0417vw;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #1EA364;
    }
    .five:hover,.five:active {
      background-image:url("../../../assets/131.jpg");
      background-size: 100% 100%;
      background-repead: no-repead;
    }
    .five:hover .div1{
      color: white;
    }
    .five:hover .button1{
      background: #1EA364;
    }
    .five:hover .span3{
      color: white;
    }
    .five:hover .span4{
      color: white;
    }
</style>
